import React from 'react';

import {Button, CheckIcon, ModalPopup} from '@kit';

import {useCharacter} from '../../../character-context';
import {useFeatureAction} from '../use-feature-action';
import type {ProcedureModalProps} from './procedure-modal-props';

import css from '../../sheet.module.css';

/** Магическая изворотливость: вернуть до половины ячеек договора, округлённой вверх */
export const PactSlotRecoveryModal: React.FC<ProcedureModalProps<'pactSlotRecovery'>> = ({action, onClose}) => {
	const {character} = useCharacter();
	const {spend, canUse} = useFeatureAction(action);
	const pact = character.spellSlots.find((slot) => slot.pact);
	const restored = pact ? Math.min(pact.spent, Math.ceil(pact.max / 2)) : 0;

	const recover = () => {
		spend(`ячейки договора: +${restored}`, (current) => ({
			spentSpellSlots: {
				...current.spentSpellSlots,
				pact: Math.max(0, (current.spentSpellSlots.pact || 0) - restored),
			},
		}));
		onClose();
	};

	return (
		<ModalPopup open onClose={onClose} header={action.title} maxWidth={480}>
			{pact ? (
				<p>
					Ячейки договора {pact.level}-го круга: потрачено {pact.spent} из {pact.max}, вернётся{' '}
					<b>{restored}</b>.
				</p>
			) : (
				<p className={css.muted}>У персонажа нет ячеек Магии договора.</p>
			)}
			<div className={css.modalButtons}>
				<Button appearance="secondary" onClick={onClose}>
					Отмена
				</Button>
				<Button appearance="primary" icon={<CheckIcon />} disabled={!canUse || !restored} onClick={recover}>
					Восстановить
				</Button>
			</div>
		</ModalPopup>
	);
};
